import { styled } from "@styles";

export const Container = styled("div", {
  position: "fixed",
  top: "$24px",
  right: "$24px",
  display: "flex",
  flexDirection: "column",
  zIndex: 1000,

  // lobotomized owl hack (*+*), because the 'gap' property does not work from safari 14 and below
  "> * + *": {
    marginTop: "$24px",
  },

  "@sm": {
    top: "auto",
    right: "auto",
    bottom: "$24px",
    width: "100%",
    padding: "0 $16px",
  },
});
